import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { PresentationContainer } from '@Components/index';
import { useAppDispatch } from '@Hooks/index';
import { useGetUserInfoMutation } from '@Store/api/userApiSlice';
import { userInfoActions } from '@Store/slices/userInfoSlice';
import { MaterialRequisitionApproveForm } from '@Features/MaterialRequest/requests/MaterialRequisition/form';
import { useGetRequisitionQuery } from '@Features/MaterialRequest/requests/MaterialRequisition/store/api/MaterialRequestApiSlice';

const MaterialApproveForm: React.FC = () => {
  const { taskId, requestId } = useParams<{
    taskId: string;
    requestId: string;
  }>();
  const dispatch = useAppDispatch();

  const { data, isSuccess } = useGetRequisitionQuery(requestId!);
  const [getUser] = useGetUserInfoMutation();

  useEffect(() => {
    if (data?.createdBy) {
      getUser({ empId: data?.createdBy })
        .unwrap()
        .then((user) => {
          dispatch(userInfoActions.setCreatedUserRequest(user));
        });
    }
  }, [data?.createdBy]);

  if (!isSuccess || !data) {
    return null;
  }

  return (
    <PresentationContainer fullHeight>
      <MaterialRequisitionApproveForm taskId={taskId!} formData={data} />
    </PresentationContainer>
  );
};

export default MaterialApproveForm;
